import { BasicButton } from "@/components";
import { DOWNLOAD_LINKS } from "@/libraries/constant";
import { isAuthenticating } from "@/libraries/helper";
import { redirectUser } from "@/redux/reducers/auth";
import { AuthWebviewSchema } from "@/schemas";
import Box from "@mui/material/Box";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const Route = createFileRoute("/payment-success")({
	validateSearch: zodSearchValidator(AuthWebviewSchema),
	beforeLoad: async () => {
		if (!isAuthenticating()) {
			throw redirect({
				to: "/",
				replace: true,
			});
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const dispatch = useDispatch();
	useEffect(() => {
		const indexTimeout = setTimeout(() => {
			dispatch(
				redirectUser({
					is_mobile: true,
					web_redirect: `${window.location.origin}/account`,
				}),
			);
		}, 1000);

		return () => {
			clearTimeout(indexTimeout);
		};
	}, [dispatch]);

	return (
		<>
			<div className="container wrapper h-full bg-success">
				<Box className="h-full flex flex-col justify-center items-center px-8">
					<img
						src="/images/icon-success.svg"
						alt="icon-success"
						loading="lazy"
					/>
					<h1 className="text-dark text-[22px] text-center leading-7 font-bold mt-6 mb-2">
						Premium Activated
					</h1>
					<p className="text-gray-100 text-sm text-center mb-6">
						Your premium subscription has been activated.
					</p>
					<Link to={"/manage-subscription"}>
						<BasicButton
							variant="contained"
							color="secondary"
							className="w-[126px] !h-12 !text-sm !shadow-none"
						>
							Continue
						</BasicButton>
					</Link>
					<Box className="absolute bottom-0 p-4">
						<p className="text-base text-dark text-center font-medium mb-1">
							Download Our App
						</p>
						<Box className="flex gap-1">
							<a
								href={DOWNLOAD_LINKS.APP_STORE}
								target="_blank"
								rel="noopener noreferrer"
							>
								<button type="button">
									<img src="/images/apple-button.svg" alt="apple" />
								</button>
							</a>
							<a
								href={DOWNLOAD_LINKS.PLAY_STORE}
								target="_blank"
								rel="noopener noreferrer"
							>
								<button type="button">
									<img src="/images/google-play-button.svg" alt="google-play" />
								</button>
							</a>
						</Box>
					</Box>
				</Box>
			</div>
		</>
	);
}
